var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return Number(_vm.category.examsCount) > 0 || this.showEmpty
    ? _c(
        "div",
        { staticStyle: { "padding-left": "0px", width: "100%" } },
        [
          _vm.isCategoryRoot && _vm.isShowCategory
            ? _c(
                "div",
                {
                  staticClass: "d-flex",
                  class: "category-" + _vm.activeClass + " root-category",
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "v-col",
                    { attrs: { lg: "12", md: "12", sm: "12", cols: "12" } },
                    [
                      _c(
                        "a",
                        {
                          class: "root-class",
                          on: { click: _vm.clickCategory },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.category.name) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm.isShowCategory
            ? _c(
                "div",
                {
                  staticClass: "d-flex",
                  class: "category-" + _vm.activeClass,
                  attrs: { cols: "12" },
                },
                [
                  _vm.category.parentIsRoot
                    ? [
                        _c(
                          "v-col",
                          {
                            attrs: { lg: "10", md: "10", sm: "10", cols: "10" },
                          },
                          [
                            _c(
                              "a",
                              {
                                class: "second-class",
                                on: { click: _vm.clickCategory },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.category.name) +
                                    " " +
                                    _vm._s(
                                      Number(_vm.category.examsCount) > 0
                                        ? "(" + _vm.category.examsCount + ")"
                                        : ""
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.category.hasChildren
                          ? _c(
                              "v-col",
                              {
                                staticClass: "cursor-pointer",
                                attrs: { lg: "1", md: "1", sm: "1", cols: "1" },
                              },
                              [
                                _c("i", {
                                  class:
                                    "v-icon notranslate mdi mdi-chevron-" +
                                    _vm.arrow,
                                  attrs: { "aria-hidden": "true" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickPullDown()
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _c(
                          "v-col",
                          {
                            class: "category-" + _vm.activeClass,
                            attrs: { lg: "12", md: "12", sm: "12", cols: "12" },
                          },
                          [
                            _c("a", { on: { click: _vm.clickCategory } }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.category.name) +
                                  " " +
                                  _vm._s(
                                    Number(_vm.category.examsCount) > 0
                                      ? "(" + _vm.category.examsCount + ")"
                                      : ""
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ]
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.visible
            ? _c(
                "transition-group",
                { attrs: { name: "fade" } },
                _vm._l(_vm.category.children, function (subCategory) {
                  return _c(
                    "div",
                    { key: subCategory.name, staticClass: "d-flex" },
                    [
                      _c("ExamCategory", {
                        attrs: {
                          exams: _vm.exams,
                          "show-empty": true,
                          category: subCategory,
                          isCategoryRoot: false,
                          visible: _vm.isActive,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }